const EARTH_ARC_START = 335;
const EARTH_ARC_END = 600;
const PATH_BEZIER_Y = 0;
const PLANET_ARC_START = 300;
const PLANET_ARC_END = 560;
const PLANET_SCALE = 0.6;
const PLANET_ORIG = 420;
const EARTH_TOP = 244;
const EARTH_LEFT = 22;
const EARTH_ORIG = 60;
const FOCUS_ORIG = 735;
const FOCUS_TOP_OFFSET = 2;
const PATH_TOP_OFFSET = 25;
const ORBIT_WIDTH = 1200;
const ORBIT_HEIGHT = 772;

let scEl, swEl, sicEl, pEl, eEl, cEl, c2d, ssEl, oEl, pOrig, eOrig, focusActive = false, pBs, drawTimeout, missions, self;

module.exports = {

    init: function(missionsObj) {
        scEl = document.getElementById('ss-container');
        pEl = document.getElementById('focus-planet');
        eEl = document.getElementById('focus-earth');
        cEl = document.getElementById('ss-canvas');
        swEl = document.getElementById('ss-wrapper');
        c2d = cEl.getContext('2d');
        ssEl = document.getElementById('ss');
        sicEl = document.getElementById('ss-info-close');
        missions = missionsObj;
    },

    clearRect: function() {
        c2d.clearRect(0, 0, cEl.width, cEl.height);
    },

    overlayPlanet: function(planetName, fEl, grabBS) {
        let jEl = document.querySelector('#' + planetName + ' .planet'),
            size = jEl.offsetWidth,
            bRect = jEl.getBoundingClientRect(),
            scRect = scEl.getBoundingClientRect();
        fEl.style.boxShadow = window.getComputedStyle(jEl).getPropertyValue('box-shadow');
        this.setPVals(fEl, bRect, scRect);
        fEl.classList.add(planetName);
        if (grabBS) {
            pBs = window.getComputedStyle(jEl).getPropertyValue('box-shadow');
        }
        return jEl;
    },

    setPVals: function(el, rect, scRect, bs) {
        el.style.width = rect.width + 'px';
        el.style.height = rect.height + 'px';
        el.style.top = rect.top - scRect.top + 'px';
        el.style.left = rect.left - scRect.left + 'px';
        el.style.display = 'block';
        if(bs) {
            el.style.boxShadow = bs;
        }
    },

    calcFocusSize: function(fEl, isEarth) {
        let sW = scEl.clientWidth,
            sH = ssEl.clientHeight,
            resp = {},
            eW, eLeft, bsW, ohr;
        ohr = sH / ORBIT_HEIGHT;
        //eW = (sW > sH) ? sH * PLANET_SCALE : sW * PLANET_SCALE;
        eW = PLANET_ORIG * ohr;
        bsW = eW / 4;

        resp.oHeight = sH;
        resp.oWidth = ORBIT_WIDTH * ohr;
        resp.oLeft = (sW - resp.oWidth) / 2;
        resp.ratio = ohr;

        if (isEarth) {
            eLeft = (sW - eW) / 2;
            fEl.style.width = eW + 'px';
            fEl.style.height = eW + 'px';
            fEl.style.top = ((sH - eW) / 2) + PATH_TOP_OFFSET + 'px';
            fEl.style.left = eLeft + 'px';
        } else {
            eLeft = FOCUS_ORIG * ohr;
            fEl.style.width = eW + 'px';
            fEl.style.height = eW + 'px';
            fEl.style.top = ((sH - eW) / 2) + PATH_TOP_OFFSET + FOCUS_TOP_OFFSET + 'px';
            fEl.style.left = eLeft + resp.oLeft + 'px';
        }
        if(fEl.classList.contains('bennu')) {
            fEl.style.boxShadow = 'none';
        } else {
            fEl.style.boxShadow = 'inset ' + bsW + 'px 0 ' + bsW + 'px rgba(0,0,0,.5)';
        }

        resp.eLeft = eLeft;

        return resp;
    },

    drawAnimate: function(current, end, step, timeout, xCalc, yCalc, callback) {
        let self = this;
        if (current < end) {
            drawTimeout = window.setTimeout(function () {
                let pX = xCalc.call(this, current),
                    pY = yCalc.call(this, current);
                c2d.fillRect(pX, pY, 1, 1);
                self.drawAnimate(current + step, end, step, timeout, xCalc, yCalc, callback);
            }, timeout)
        } else if (callback) {
            callback.call(this, xCalc.call(this, current - step), yCalc.call(this, current - step))
        }
    },

    drawEarthPath: function(eRect, scRect, eW, callback) {
        let cY = eRect.top - scRect.top + (eW / 2),
            cX = eRect.left - scRect.left + (eW / 2),
            r = eW * .75;
        this.drawAnimate(EARTH_ARC_START, EARTH_ARC_END, 1.5, 1, function (xc) {
            return r * Math.cos(xc * Math.PI / 180) + cX;
        }, function (yc) {
            return r * Math.sin(yc * Math.PI / 180) + cY;
        }, callback);
    },

    drawArcParth: function(sX, sY, eX, eY, callback) {
        let bezierX = sX + (eX - sX) / 2;

        this.drawAnimate(0, 1, .0015, 1, function (xc) {
            return (1 - xc) * (1 - xc) * sX + 2 * (1 - xc) * xc * bezierX + xc * xc * eX;
        }, function (yc) {
            return (1 - yc) * (1 - yc) * sY + 2 * (1 - yc) * yc * PATH_BEZIER_Y + yc * yc * eY;
        }, callback);
    },

    getArcEnd: function(pRect, scRect, pW) {
        let cY = pRect.top - scRect.top + (pW / 2),
            cX = pRect.left - scRect.left + (pW / 2),
            r = pW * .6;
        return {
            x: r * Math.cos(PLANET_ARC_START * Math.PI / 180) + cX,
            y: r * Math.sin(PLANET_ARC_START * Math.PI / 180) + cY
        }
    },

    drawPlanetPath: function(pRect, scRect, pW) {
        let cY = pRect.top - scRect.top + (pW / 2),
            cX = pRect.left - scRect.left + (pW / 2),
            r = pW * .6;
        this.drawAnimate(PLANET_ARC_START, PLANET_ARC_END, .3, 1, function (xc) {
            return r * Math.cos(xc * Math.PI / 180) + cX;
        }, function (yc) {
            return r * Math.sin(yc * Math.PI / 180) + cY;
        });
    },

    drawPath: function() {
        let eRect = eEl.getBoundingClientRect(),
            pRect = pEl.getBoundingClientRect(),
            scRect = scEl.getBoundingClientRect(),
            eW = eEl.offsetWidth,
            pW = pEl.offsetWidth,
            self = this;
        c2d.clearRect(0, 0, cEl.width, cEl.height);
        cEl.style.display = 'block';
        cEl.width = cEl.offsetWidth;
        cEl.height = cEl.offsetHeight;
        c2d.fillStyle = 'rgba(255,255,255,0.8)';
        this.drawEarthPath(eRect, scRect, eW, function (eX, eY) {
            let ae = self.getArcEnd(pRect, scRect, pW);
            self.drawArcParth(eX, eY, ae.x, ae.y, function () {
                self.drawPlanetPath(pRect, scRect, pW);
            });
        });
    },

    showPath: function(type, sizes) {
        oEl = document.getElementById('ss-orbit-' + type);
        oEl.style.width = sizes.oWidth + 'px';
        oEl.style.height = sizes.oHeight + 'px';
        oEl.style.left = sizes.oLeft + 'px';
        oEl.style.display = 'block';
        window.setTimeout(function() {
            oEl.classList.add('active');
            oEl.addEventListener('click', self.resetFocus);
            sicEl.addEventListener('click', self.resetFocus);
            swEl.addEventListener('click', self.resetFocus);
        }, 100);
    },

    drawEarthOnly: function() {
        let pRect = pEl.getBoundingClientRect(),
            scRect = scEl.getBoundingClientRect(),
            pW = pEl.offsetWidth,
            self = this;
        c2d.clearRect(0, 0, cEl.width, cEl.height);
        cEl.style.display = 'block';
        cEl.width = cEl.offsetWidth;
        cEl.height = cEl.offsetHeight;
        c2d.fillStyle = 'rgba(255,255,255,0.8)';
        self.drawPlanetPath(pRect, scRect, pW);
    },

    resetFocus: function() {
        let scRect = scEl.getBoundingClientRect();
        cEl.removeEventListener('click', self.resetFocus);
        self.setPVals(pEl, pOrig.getBoundingClientRect(), scRect, pBs);
        if(eOrig) {
            self.setPVals(eEl, eOrig.getBoundingClientRect(), scRect);
        }
        document.querySelector('#ss-wrapper').classList.remove('hide');
        window.clearTimeout(drawTimeout);
        c2d.clearRect(0, 0, cEl.width, cEl.height);
        cEl.style.display = 'none';
        if(oEl) {
            oEl.classList.remove('active');
            oEl.style.display = 'none';
            oEl.removeEventListener('click', self.resetFocus);
            swEl.removeEventListener('click', self.resetFocus);
            sicEl.removeEventListener('click', self.resetFocus);
        }
        window.setTimeout(function () {
            pEl.style.display = 'none';
            pEl.className = '';
            eEl.style.display = 'none';
            ssEl.classList.remove('paused');
            focusActive = false;
        }, 1000);
        missions.resetName();
    },

    setFocus(planetName, mission) {
        self = this;
        let isLander = missions.getIsLander(mission);
        if (focusActive) {
            return;
        }
        focusActive = true;
        ssEl.classList.add('paused');
        pOrig = this.overlayPlanet(planetName, pEl, true);
        if(planetName !== 'earth') {
            eOrig = this.overlayPlanet('earth', eEl);
            

            window.setTimeout(function () {
                let sizes = self.calcFocusSize(pEl);

                eEl.style.top = sizes.ratio * EARTH_TOP + PATH_TOP_OFFSET + 'px';
                eEl.style.left = sizes.oLeft + (sizes.ratio * EARTH_LEFT) + 'px';
                eEl.style.width = sizes.ratio * EARTH_ORIG + 'px';
                eEl.style.height = sizes.ratio * EARTH_ORIG + 'px';

                drawTimeout = window.setTimeout(function () {
                    //self.drawPath();
                    self.showPath((isLander) ? 'l' : 'p', sizes);
                }, 1300);
            }, 10);

        } else { /* is Earth */
            eOrig = null;
            let sizes = self.calcFocusSize(pEl, true);
            drawTimeout = window.setTimeout(function () {
                //self.drawEarthOnly();
                self.showPath('e', sizes);
            }, 1300);
        }

        document.querySelector('#ss-wrapper').classList.add('hide');

        window.setTimeout(function () {
            cEl.addEventListener('click', self.resetFocus);
        }, 300);
    }
    
}
